import {styled} from "@mui/material";

export const InputWithSelectContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '1rem'
}));